import { FC, useContext } from 'react';

import { ProcessingPayment } from '@onlinepayments/payments-library';
import { RouteComponentProps } from 'react-router-dom';

import { Card } from '../components/toolkit';
import { Path } from '../enums/Path';
import { PayorderContext } from '../PayorderContext';
import { getCountryAndLanguage } from '../utils/localization';

const ProcessingPaymentPage: FC<RouteComponentProps> = ({ history }) => {
  const {
    contextState: { orderDetails },
  } = useContext(PayorderContext);

  return (
    <Card testId="PaymentProcessingPage" className="PaymentProcessingContainer">
      <ProcessingPayment
        onError={() => {
          history.push(Path.ReviewAndPay);
        }}
        onSuccess={() => {
          let orderNumber = localStorage.getItem('b2b-variant-order');
          if (orderNumber != null && window.payorder.B2B_RETURN_URL) {
            const { countryCode, languageCode } = getCountryAndLanguage();
            localStorage.removeItem('b2b-variant-order');
            if (orderDetails.response) {
              orderNumber = orderDetails.response.orderNumber;
            }
            window.location.href = `${window.payorder.B2B_RETURN_URL}/${countryCode}/${languageCode}/?orderNumber=${orderNumber}`;
          } else {
            history.push(Path.Confirmation);
          }
        }}
      />
    </Card>
  );
};
export default ProcessingPaymentPage;
